function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.6552,
  cy: 24.9033,
  r: 23.8483,
  fill: "black",
  stroke: "black",
  strokeWidth: 2.11
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.1582 25.4927C20.2753 23.7293 22.9435 22.7637 25.6988 22.7637C28.4541 22.7637 31.1223 23.7293 33.2394 25.4927",
  stroke: "white",
  strokeWidth: 2.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3232 21.6917C17.4535 18.9325 21.4828 17.4102 25.6556 17.4102C29.8283 17.4102 33.8576 18.9325 36.9879 21.6917",
  stroke: "white",
  strokeWidth: 2.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.9385 29.3048C23.0259 28.5322 24.3267 28.1172 25.6606 28.1172C26.9945 28.1172 28.2953 28.5322 29.3827 29.3048",
  stroke: "white",
  strokeWidth: 2.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.6562 33.4746H25.6678",
  stroke: "white",
  strokeWidth: 2.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.7066,
  height: 25.7066,
  fill: "white",
  transform: "translate(12.8027 12.0508)"
})));

var SvgWifiFocus = function SvgWifiFocus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWifiFocus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wifi_focus.90d83e34.svg";
export { ForwardRef as ReactComponent };